"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./responses"));
__export(require("./taxonomy-group.class"));
__export(require("./taxonomy-system-attributes.class"));
__export(require("./taxonomy-terms.class"));
//# sourceMappingURL=index.js.map